"use client"

import { useState, useEffect } from "react"
import { usePathname, useSearchParams } from "next/navigation"
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/modules/components/ui/pagination"
import { BASE_URL } from "@lib/config"

export default function PaginationCerw(props) {
  const { pagination, onPageChange, baseUrl, currentPath } = props
  // const searchParams = useSearchParams() // searchParams 未在此组件中使用，可以考虑移除
  // const [paginationInfo, setPaginationInfo] = useState({ page: 1, pageCount: 1, pageSize:1, total:1 });
  
  let host = baseUrl;
  if (!host && typeof window !== "undefined") { 
    host = window.location.origin;
  }

  // useEffect(() => {
  //   if (pagination) {
  //       setPaginationInfo(pagination);
  //   }
  // }, [pagination])

  // 使用 props.pagination 或提供默认值，防止 undefined 错误
  const currentPage = pagination?.page || 1;
  const totalPages = pagination?.pageCount || 1;

  const handlePageChange = (page) => {
    if (onPageChange) {
      onPageChange(page)
    }
  }

  const getPageNumbers = () => {
    // const currentPage = paginationInfo.page || 1; // 使用新的 currentPage
    // const totalPages = paginationInfo.pageCount || 1; // 使用新的 totalPages
    let pageNumbers: number[] = [];

    if (totalPages <= 3) {
      pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else if (currentPage <= 2) {
      pageNumbers = [1, 2, 3];
    } else if (currentPage >= totalPages - 1) {
      pageNumbers = [totalPages - 2, totalPages - 1, totalPages];
    } else {
      pageNumbers = [currentPage - 1, currentPage, currentPage + 1];
    }

    return pageNumbers;
  }

  const pageNumbers = getPageNumbers();

  // 如果 totalPages 为0或1，不渲染分页控件
  if (totalPages <= 1) {
    return null;
  }

  return (
    <Pagination>
      <PaginationContent className="gap-0 lg:gap-1">
        <PaginationItem>
        <PaginationPrevious
            disabled={currentPage <= 1} // 使用新的 currentPage
            href={currentPage > 1 ? `${host}${currentPath}?page=${currentPage - 1}` : '#'} // 使用新的 currentPage
          />
        </PaginationItem>

        {currentPage > 2 && totalPages > 3 && ( // 使用新的 currentPage 和 totalPages
          <>
            <PaginationItem>
              <PaginationLink href={`${host}${currentPath}?page=1`}>1</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationEllipsis />
            </PaginationItem>
          </>
        )}

        {pageNumbers.map((pageNumber) => (
          <PaginationItem key={pageNumber}>
            <PaginationLink
              href={`${host}${currentPath}?page=${pageNumber}`}
              isActive={pageNumber === currentPage} // 使用新的 currentPage
              className={pageNumber === currentPage ? "font-bold text-[rgb(255_122_0_/_0.85)]" : ""} // 使用新的 currentPage
            >
              {pageNumber}
            </PaginationLink>
          </PaginationItem>
        ))}

        {currentPage < totalPages - 1 && totalPages > 3 && ( // 使用新的 currentPage 和 totalPages
          <>
            <PaginationItem>
              <PaginationEllipsis />
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href={`${host}${currentPath}?page=${totalPages}`}> {/* 使用新的 totalPages */}
                {totalPages} {/* 使用新的 totalPages */}
              </PaginationLink>
            </PaginationItem>
          </>
        )}

        <PaginationItem>
        <PaginationNext
            disabled={currentPage >= totalPages} // 使用新的 currentPage 和 totalPages
            href={currentPage < totalPages ? `${host}${currentPath}?page=${currentPage + 1}` : '#'} // 使用新的 currentPage 和 totalPages
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}